import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear tokens and user profile from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_profile');

    // Redirect to the login page
    navigate('/login');
  }, [navigate]);

  return (
    <div>
      <p>Logging you out...</p>
    </div>
  );
};

export default Logout;
